/**
 * Money on a DOCUMENT - an invoice, a quote, a statement: always with its cents.
 *
 * `fmtMoney` in `format.ts` is the plan-price helper and drops the cents of a
 * whole amount, which is right for "9 €/month" and wrong for a ledger: "384 €"
 * above "900,60 €" puts two different numbers of digits in one column, and a
 * client comparing the page with their bank statement is looking for "384,00".
 *
 * Estonian in `et-EE`, everything else in `en-GB` ("€45.00", and a day-first
 * date beside it) - the same two-way rule the date helpers in `format.ts`
 * follow.
 *
 * A file of its own, with no import from the UI kit: the kit pulls in a
 * stylesheet, and a module that imports it cannot be loaded by the node test
 * runner.
 */
export function fmtAmount(cents: number, currency: string, locale: string): string {
  try {
    return new Intl.NumberFormat(locale === "et" ? "et-EE" : "en-GB", {
      style: "currency",
      currency: currency || "EUR",
    }).format(cents / 100);
  } catch {
    // An unknown currency code throws; the figure is still worth printing.
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}
